export default __webpack_public_path__ + "static/media/spinomenal.dbe3e43e.svg";